module.exports = __webpack_public_path__ + "img/CHINA_RE.ccb768dc.jpg";